import { DataTable } from '@app/components/data-table/data-table';
import { DataTableToolbar } from '@app/components/data-table/data-table-toolbar';
import { useDataTable } from '@app/components/data-table/hooks/use-data-table';
import { DataTableProps } from '@app/components/data-table/types/data-table';
import CreatePackagingForm from '@app/components/product-form/create-ppt-forms/create-packaging-form';
import useSimpleDialog from '@app/hooks/use-simple-dialog';
import { Button } from '@shared/components/ui/button';
import { useToast } from '@shared/components/ui/use-toast';
import { PackagingResponseType } from '../packaging-list-page';
import { useGetPackagingColumns } from './packaging-table-columns';

interface PackagingTableProps extends DataTableProps<PackagingResponseType> {
  includeCreateButton?: boolean;
}

export default function PackagingTable({
  data,
  refetch,
  includeCreateButton = true,
  isLoading,
  isFetchedAfterMount,
  isPreviousData,
  status,
}: PackagingTableProps) {
  const { toast } = useToast();

  const {
    showSimpleDialog: showCreatePackagingDialog,
    SimpleDialogComponent: CreatePackagingDialog,
    closeSimpleDialog: closeCreatePackagingDialog,
  } = useSimpleDialog();

  const { table } = useDataTable({
    data: data?.packagingTypes || [],
    columns: useGetPackagingColumns(),
    initialState: {
      columnVisibility: {
        uuid: false,
      },
    },
  });

  return (
    <>
      <DataTable
        table={table}
        className="bg-gray-00"
        isLoading={(!isFetchedAfterMount && isPreviousData) || isLoading}
        tableLoading={!data && status === 'loading'}
      >
        <DataTableToolbar table={table}>
          {includeCreateButton && (
            <Button size="sm" onClick={() => showCreatePackagingDialog()}>
              Create
            </Button>
          )}
        </DataTableToolbar>
      </DataTable>
      {CreatePackagingDialog({
        header: 'Add packaging data',
        content: (
          <CreatePackagingForm
            onPackagingCreated={() => {
              closeCreatePackagingDialog();
              toast({
                title: 'Packaging item created successfully',
                variant: 'success',
              });
              refetch && refetch();
            }}
          />
        ),
      })}
    </>
  );
}
